import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import App from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { Toaster } from "./components/Toaster";
import { ToastProvider } from "./components/ToastContext";
import "./index.css";
import { initPostHog } from "./lib/posthog";
import { initSentry } from "./lib/sentry";
import { reloadOnceForStaleChunk } from "./lib/chunkReload";

initSentry();
initPostHog();

// Vite fires `vite:preloadError` when a <link rel="modulepreload"> for a route
// chunk fails — typically a stale tab requesting a hash a deploy already deleted.
// Catch it before the import() even rejects and reload once to the fresh build.
// (Shares the same one-shot guard as lazyWithReload, so at most one reload.)
window.addEventListener("vite:preloadError", (event) => {
  if (reloadOnceForStaleChunk()) event.preventDefault();
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {/* Single top-level boundary: an uncaught render error anywhere in the
        app degrades to a retry-able surface instead of a blank screen. */}
    <ErrorBoundary>
      {/* ToastProvider sits inside the boundary so toast plumbing can't crash
          the whole app, and wraps the router so any route can emit toasts.
          Toaster is a single fixed-position host mounted once after <App />. */}
      <ToastProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
        <Toaster />
      </ToastProvider>
    </ErrorBoundary>
  </StrictMode>,
);
